import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { showPopup } from "/redux/action-creaters/popup";
import { popupTypes } from "/redux/reducers/popupReducer";
import { shouldSkipApiRequestForRobot } from "/utils";
import {
  fetchDomains,
  getDeliveryCityData,
  setLocation,
} from "/redux/action-creaters/location";
import Button from "/components/common/button";
import { setCityConfirmActive } from "/redux/action-creaters/pageState";
import { safeLocalStorage } from "~/utils/safeStorage";
import styles from "./index.module.scss";
import { ApiClient } from "../../../../api/client";
import { setLocationLogic } from "../../../../utils/location";

// Окно «Ваш город ...?»: определяем город по IP и предлагаем подтвердить.
// Раньше жило прямо в шапке — логика та же, вынесена отдельным компонентом.
//
// Закрывается крестиком, Esc и кликом вне окна. Город при закрытии не
// меняется: он применяется только по «Да, верно» (UX-05).
//
// Это первый элемент в очереди оверлеев: пока идёт определение города и
// открыто окно, флаг isCityConfirmActive держит баннер куки закрытым (UX-04).
export default function DetectedCity() {
  const dispatch = useDispatch();
  const { cityName, domains } = useSelector((state) => state.location);
  const [detectedCity, setDetectedCity] = useState(null);

  useEffect(() => {
    if (typeof window !== "object") {
      return;
    }

    if (cityName === "Россия") {
      const isDetected = safeLocalStorage.getItem("isCityDetected");
      if (!shouldSkipApiRequestForRobot() && !isDetected) {
        safeLocalStorage.setItem("isCityDetected", "true");
        // eslint-disable-next-line no-use-before-define
        detectCity();
      }
    }
  }, [cityName]);

  const detectCity = async () => {
    // очередь занимаем до запроса, иначе баннер куки успеет мигнуть
    dispatch(setCityConfirmActive(true));
    await dispatch(fetchDomains());
    const detectedCity = await ApiClient.dadata.detectCity();
    if (detectedCity && detectedCity?.city) {
      setDetectedCity(detectedCity);
      return;
    }
    // город не определился — очередь освобождается сразу
    dispatch(setCityConfirmActive(false));
  };

  useEffect(() => {
    const body = document.querySelector("body");
    if (!detectedCity) {
      body.classList.remove("popup");
    } else {
      body.classList.add("popup");
    }
  }, [detectedCity]);

  const closePopup = () => {
    setDetectedCity(null);
    dispatch(setCityConfirmActive(false));
  };

  useEffect(() => {
    if (!detectedCity?.city) {
      return undefined;
    }
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closePopup();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [detectedCity]);

  const setCity = async () => {
    await dispatch(getDeliveryCityData(detectedCity, true));
    await dispatch(setLocation(detectedCity.city));

    setLocationLogic(detectedCity.city, detectedCity, domains);
    closePopup();
  };

  if (!detectedCity?.city) {
    return null;
  }

  return (
    <noindex>
      <div className={styles.Wrapper} onClick={closePopup}>
        <div
          onClick={(e) => e.stopPropagation()}
          className={styles.DetectedPopup}
        >
          <button
            type="button"
            className={styles.Close}
            onClick={closePopup}
            aria-label="Закрыть окно"
            data-test="detectedCityClose"
          >
            <svg
              width="54"
              height="54"
              viewBox="0 0 54 54"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 0H46C50.4183 0 54 3.58172 54 8V54H30C13.4315 54 0 40.5685 0 24V0Z"
                fill="#FFEFEE"
              />
              <path
                d="M20 20L34 34"
                stroke="#FF584C"
                strokeWidth="0.8"
                strokeLinecap="round"
              />
              <path
                d="M34 20L20 34"
                stroke="#FF584C"
                strokeWidth="0.8"
                strokeLinecap="round"
              />
            </svg>
          </button>
          <div className={styles.DetectedCity}>
            Ваш город {detectedCity.city}?
          </div>
          <div className={styles.DetectedButtons}>
            <Button onClick={setCity} label={"Да, верно"} />
            <Button
              onClick={() => {
                dispatch(showPopup(popupTypes.locationNew));
                closePopup();
              }}
              type={"outline"}
              label={"Выбрать другой"}
            />
          </div>
        </div>
      </div>
    </noindex>
  );
}
